import styled from 'theme';

import { BaseItemRow, BaseItemWidth } from '../CertificatesGroup.styles';

export const CertificateItemRow = styled(BaseItemRow)``;

export const CertificateValidIcon = styled(BaseItemWidth)`
  img {
    width: 1.5rem;
    height: 1.5rem;
    vertical-align: middle;
  }
`;

export const CertificateInvalidIcon = styled(BaseItemWidth)`
  img {
    width: 1.3rem;
    height: 1.3rem;
    vertical-align: middle;
  }
`;

export const CertificateItemValue = styled(BaseItemWidth)`
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  color: ${p => p.theme.variables.customColors.grayMedium};
`;
